export const SESSION_STORAGE_SATISFACTION_SURVEY_DISMISSED = 'satisfactionSurveyDismissed';

export function isSatisfactionSurveyDismissed(): boolean {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_SATISFACTION_SURVEY_DISMISSED) === 'true';
  } catch {
    return false;
  }
}

export function dismissSatisfactionSurvey(): void {
  try {
    sessionStorage.setItem(SESSION_STORAGE_SATISFACTION_SURVEY_DISMISSED, 'true');
  } catch (error) {
    console.error('Falha ao gravar dismiss da pesquisa de satisfação', error);
  }
}

export function clearSatisfactionSurveySession(): void {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_SATISFACTION_SURVEY_DISMISSED);
  } catch (error) {
    console.error('Falha ao limpar sessão da pesquisa de satisfação', error);
  }
}
